export default "__VITE_ASSET__CYDiyLPS__"